import styled from '@emotion/styled';
import { WistiaPlayer } from '@wistia/wistia-player-react';

type MarketingVideoProps = {
  mediaId: string;
  height?: number;
  onPlay?: () => void;
};

const Wrapper = styled.div`
  pointer-events: none;
`;

// Used for silent autoplay looping videos
export const MarketingVideoEmbed = (props: MarketingVideoProps) => {
  const { mediaId, height, onPlay } = props;

  return (
    <Wrapper>
      <WistiaPlayer
        mediaId={mediaId}
        style={
          height
            ? {
                height: `${height}px`,
              }
            : undefined
        }
        autoplay
        playBarControl={false}
        volumeControl={false}
        qualityControl={false}
        settingsControl={false}
        fullscreenControl={false}
        playPauseControl={false}
        endVideoBehavior="loop"
        controlsVisibleOnLoad={false}
        onPlay={onPlay}
        muted
      />
    </Wrapper>
  );
};
